























































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import MmHintedButton from '../../components/MmHintedButton.vue';
import MmStatusBadge from '../../components/MmStatusBadge.vue';
import { formatDateTime, formatMonitoringSelectLabel, MM_EMPTY_DASH, orDash } from '../../core/format';
import { resolveTaskMonitoringLevel } from '../../core/monitoringLevel';
import { getBadgeSpec } from '../../core/statuses';
import { MmMonitoringBatch } from '../results/batch';
import { MmTask } from '../../types/domain';
import { MmMonitoringLevel } from '../../types/enums';

const KEY = 'priceMonitoring.mobileMonitoring.taskCard.';

/** Ключи локали перечислены целиком: собранный конкатенацией не находится поиском и ломается молча */
const LEVEL_LABEL_KEYS: { [key: string]: string } = {
	group: KEY + 'levelGroup',
	category: KEY + 'levelCategory',
	subcategory: KEY + 'levelSubcategory',
};

/** Поля в контракте нет, поэтому читаем его по имени ровно в одном месте */
const REASSIGNED_FIELD = 'isReassigned';

@Component({
	components: { MmHintedButton, MmStatusBadge },
})
export default class TaskCardHeader extends Vue {
	@Prop({ required: true }) readonly task!: MmTask;

	@Prop({ default: 'header' }) readonly mode!: string;

	@Prop({ default: false }) readonly canPrev!: boolean;

	@Prop({ default: false }) readonly canNext!: boolean;

	@Prop({ default: null }) readonly batchSize!: number | null;

	@Prop({ default: null }) readonly monitoringBatch!: MmMonitoringBatch | null;

	@Prop({ default: null }) readonly planPositionsTotal!: number | null;

	/** С вкладкой плана число позиций берётся из planPositionsTotal, а не из resultsCount */
	@Prop({ default: false }) readonly usePlanPositions!: boolean;

	get storeTitle(): string {
		const name = this.storeName;

		return name !== MM_EMPTY_DASH ? name : this.task.competitorCode;
	}

	get storeName(): string {
		const store = this.task.competitorStore;

		return orDash(store ? store.name : null);
	}

	get storeAddress(): string {
		const store = this.task.competitorStore;

		return orDash(store ? store.address : null);
	}

	get displayNumber(): string {
		const value = this.task.displayNumber;

		return value === null || value === undefined || String(value).trim() === ''
			? ''
			: '№ ' + String(value).trim();
	}

	/* Зона берётся из полей задания, а не из справочника: магазин мог сменить кластер позже */

	get formatName(): string {
		return orDash(this.task.storeFormatName);
	}

	get regionName(): string {
		return orDash(this.task.storeRegionName);
	}

	get clusterName(): string {
		return orDash(this.task.storeClusterName);
	}

	/** Исполнителя не достраиваем по связкам: связку могли переназначить после создания задания */
	get auditorText(): string {
		const fullName = this.task.auditorFullName;
		const login = this.task.auditorLogin;

		if (fullName !== null && fullName !== undefined && String(fullName).trim() !== '') {
			return login !== null && login !== undefined && String(login).trim() !== ''
				? String(fullName).trim() + ' (' + String(login).trim() + ')'
				: String(fullName).trim();
		}

		return orDash(login);
	}

	get createdAtText(): string {
		return formatDateTime(this.task.createdAt);
	}

	get monitoringLevel(): MmMonitoringLevel {
		const classifications = this.task.classifications ? this.task.classifications : [];

		return resolveTaskMonitoringLevel(this.task.monitoringLevel, classifications);
	}

	get monitoringLevelText(): string {
		const labelKey = LEVEL_LABEL_KEYS[this.monitoringLevel];
		const label = labelKey ? (this.$t(labelKey) as string) : this.monitoringLevel;
		const count = this.task.classifications ? this.task.classifications.length : 0;

		if (count <= 0) {
			return label;
		}

		return this.$t(KEY + 'levelValue', { level: label, count: count }) as string;
	}

	get displayPositionsTotal(): number | null {
		if (this.usePlanPositions) {
			const fromPlan = this.planPositionsTotal;

			return typeof fromPlan === 'number' && !isNaN(fromPlan) ? fromPlan : null;
		}

		const fromTask = this.task.positionsTotal;

		return fromTask !== null && fromTask !== undefined ? fromTask : null;
	}

	get hasPositionsTotal(): boolean {
		const value = this.displayPositionsTotal;

		return value !== null && value !== undefined;
	}

	get hasPriceChecker(): boolean {
		const value = this.task.isPriceCheckerEnabled;

		return value !== null && value !== undefined;
	}

	get priceCheckerText(): string {
		return this.task.isPriceCheckerEnabled === true
			? (this.$t('shared.actions.yes') as string)
			: (this.$t('shared.actions.no') as string);
	}

	get commentText(): string {
		const value = this.task.comment;

		return value === null || value === undefined ? '' : String(value).trim();
	}

	get isReassigned(): boolean {
		const holder = this.task as { [key: string]: any };

		return holder[REASSIGNED_FIELD] === true;
	}

	get hasBatch(): boolean {
		const value = this.task.batchId;

		return value !== null && value !== undefined && String(value).trim() !== '';
	}

	get monitoringTitle(): string {
		const batch = this.monitoringBatch;

		if (batch === null || batch === undefined) {
			return '';
		}

		const spec = getBadgeSpec('taskType', batch.type);
		const typeLabel = spec !== null ? (this.$t(spec.labelKey) as string) : '';
		const approxLabel = batch.isApproximate
			? (this.$t('priceMonitoring.mobileMonitoring.results.monitoringApprox') as string)
			: '';

		return formatMonitoringSelectLabel({
			createdAt: batch.createdAt,
			typeLabel: typeLabel,
			storeFormatName: batch.storeFormatName,
			storeRegionName: batch.storeRegionName,
			storeClusterName: batch.storeClusterName,
			isApproximate: batch.isApproximate,
			approxLabel: approxLabel,
			fallback: '',
		});
	}

	get showBelongsLine(): boolean {
		return this.hasBatch && this.monitoringTitle !== '';
	}

	get batchHintText(): string {
		const size = this.batchSize;

		if (size === null || size === undefined || size <= 1) {
			return '';
		}

		return this.$t(KEY + 'batchHint', { count: size - 1 }) as string;
	}

	get prevDisabledReason(): string {
		return this.$t(KEY + 'prevTaskDisabled') as string;
	}

	get nextDisabledReason(): string {
		return this.$t(KEY + 'nextTaskDisabled') as string;
	}

	/** Метод, а не геттер: слоты не реактивны, и геттер запомнил бы результат первой отрисовки */
	hasActionsSlot(): boolean {
		return Boolean(
			(this.$slots && this.$slots.actions) || (this.$scopedSlots && this.$scopedSlots.actions),
		);
	}

	handleBack(): void {
		this.$emit('back');
	}

	handlePrev(): void {
		this.$emit('prev');
	}

	handleNext(): void {
		this.$emit('next');
	}

	handleGoToBatch(): void {
		this.$emit('go-to-batch', {
			batchId: this.task.batchId,
			taskId: this.task.id,
		});
	}
}
